<template>
  <!-- 回收账号 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="回收账号">
          <a-input v-model="input.SaleUser" />
        </a-form-item>
        <a-form-item label="申请账号">
          <a-input v-model="input.UserID" />
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model="input.State" style="width: 150px">
            <a-select-option value="0"> 全部</a-select-option>
            <a-select-option value="1"> 待审核</a-select-option>
            <a-select-option value="2"> 审核失败</a-select-option>
            <a-select-option value="3"> 审核成功</a-select-option>
            <a-select-option value="4"> 回收成功</a-select-option>
            <a-select-option value="5"> 恶意回收订单</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="query()"
            ><a-icon type="search"
          /></a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" class="marr10" @click="SubmitExport()" >导出</a-button>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table
      bordered
      size="small"
      row-key="ID"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :loading="loading"
      :columns="columns"
      :data-source="datarow"
      :pagination="pagination"
      @change="changepage"
    >
      <template slot="title">
        <a-row :gutter="24">
          <a-col style="float: left">
            <a-tag color="red">
              <a href="javascript:;" @click="batchdelete(1)">
                <a-icon type="delete" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">批量删除</span>
              </a>
            </a-tag>
          </a-col>
          <a-col style="float: left">
            <a-tag color="red">
              <a href="javascript:;" @click="batchdelete(2)">
                <a-icon type="delete" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">删除所有回收账号</span>
              </a>
            </a-tag>
          </a-col>
        </a-row>
      </template>
      <template slot="State" slot-scope="text, record">
        <span v-if="record.State == '1'">待审核</span>
        <span v-else-if="record.State == '2'">审核失败</span>
        <span v-else-if="record.State == '3'">审核完成</span>
        <span v-else-if="record.State == '4'">回收完成</span>
        <span v-else-if="record.State == '5'">恶意回收订单</span>
      </template>
      <template slot="Operation" slot-scope="text, record">
        <a-tooltip title="详情">
          <a @click="showmodel(record)">
            <a-icon type="profile" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
        &nbsp;&nbsp;
        <a-tooltip title="删除">
          <a @click="deleteMsg(record)">
            <a-icon type="delete" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
      </template>
    </a-table>

    <!--------------------------------------------------弹窗部份-------------------------------------------------->
    <a-modal
      v-model="visible"
      :title="tittle"
      width="60%"
      ok-text="提交"
      cancel-text="返回"
      @ok="save"
    >
      <a-form-model
        :model="edit"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 10 }"
      >
        <table class="borderclass" style="width: 98%">
          <tbody>
            <tr class="borderclass">
              <td class="borderclass">
                <a-form-model-item label="账号ID">
                  <a-input v-model="edit.UserId" disabled />
                </a-form-model-item>
              </td>
              <td class="borderclass">
                <a-form-item label="回收账号">
                  <a-input v-model="edit.SaleUser" />
                </a-form-item>
              </td>
            </tr>
            <tr class="borderclass">
              <td class="borderclass">
                <a-form-item label="VIP等级">
                  <a-input-number v-model="edit.VIPLevel" />
                </a-form-item>
              </td>
              <td class="borderclass">
                <a-form-item label="出售金额">
                  <a-input-number :step="0.01" v-model="edit.SalePrices" />
                </a-form-item>
              </td>
            </tr>
            <tr class="borderclass">
              <td class="borderclass">
                <a-form-item label="电子等级">
                  <a-input-number v-model="edit.SlotLevel" />
                </a-form-item>
              </td>
              <td class="borderclass">
                <a-form-item label="真人等级">
                  <a-input-number v-model="edit.LiveLevel" />
                </a-form-item>
              </td>
            </tr>
            <tr class="borderclass">
              <td class="borderclass">
                <a-form-item label="电子晋级礼金">
                  <a-input-number :step="0.01" v-model="edit.SlotupCash" />
                </a-form-item>
              </td>
              <td class="borderclass">
                <a-form-item label="真人晋级礼金">
                  <a-input-number :step="0.01" v-model="edit.LiveupCash" />
                </a-form-item>
              </td>
            </tr>
            <tr class="borderclass">
              <td class="borderclass">
                <a-form-item label="电子周俸禄">
                  <a-input-number :step="0.01" v-model="edit.SlotWeekBonus" />
                </a-form-item>
              </td>
              <td class="borderclass">
                <a-form-item label="真人周俸禄">
                  <a-input-number :step="0.01" v-model="edit.LiveWeekBonus" />
                </a-form-item>
              </td>
            </tr>
            <tr class="borderclass">
              <td class="borderclass">
                <a-form-item label="电子月俸禄">
                  <a-input-number :step="0.01" v-model="edit.SlotMonthBonus" />
                </a-form-item>
              </td>
              <td class="borderclass">
                <a-form-item label="真人月俸禄">
                  <a-input-number :step="0.01" v-model="edit.LiveMonthBonus" />
                </a-form-item>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="borderclass2">
          <tbody>
            <tr class="borderclass2">
              <a-form-item
                label="状态"
                :labelCol="{ span: 2, offset: 2 }"
                :wrapper-col="{ span: 19, offset: 1 }"
              >
                <a-radio-group v-model="edit.State">
                  <a-radio value="1">待审核</a-radio>
                  <a-radio value="2">审核失败</a-radio>
                  <a-radio value="3">审核成功</a-radio>
                  <a-radio value="4">回收成功</a-radio>
                  <a-radio value="5">恶意回收订单</a-radio>
                </a-radio-group>
              </a-form-item>
            </tr>
            <tr class="borderclass2">
              <br />
              <a-form-item
                label="回收备注"
                :labelCol="{ span: 2, offset: 2 }"
                :wrapper-col="{ span: 12, offset: 1 }"
              >
                <a-textarea v-model="edit.Memo"></a-textarea>
              </a-form-item>
            </tr>
            <tr class="borderclass2">
              <a-form-item label="发布时间" :labelCol="{ span: 2, offset: 2 }">
                <span>{{ edit.Fdt }}</span>
              </a-form-item>
              <a-form-item label="审核时间" :labelCol="{ span: 2, offset: 2 }">
                <span>{{ edit.Ldt }}</span>
              </a-form-item>
            </tr>
          </tbody>
        </table>
      </a-form-model>
    </a-modal>
    <!--------------------------------------------------弹窗部份-------------------------------------------------->
  </a-layout-content>
</template>
<script>
import moment from "moment";

export default {
  data() {
    return {
      datarow: [],
      columns: IninTable(),
      tittle: "",
      pagination: {
        total: 0,
        pageindex: 1,
        pagesize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true, // 可以改变每页个数
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
      },
      loading: false,
      visible: false,
      input: {
        State: "0",
        SaleUser: "",
        UserID: "",
      },
      edit: {
        ID: "0",
        UserId: "",
        SaleUser: "0",
        VIPLevel: "0",
        SlotLevel: "0",
        LiveLevel: "0",
        SlotupCash: "",
        SlotWeekBonus: "0",
        SlotMonthBonus: "0",
        LiveupCash: "0",
        LiveWeekBonus: "0",
        LiveMonthBonus: "0",
        SalePrices: "0",
        State: "0",
        Memo: "",
        Fdt: "",
        Ldt: "",
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      selectedRowKeys: [],
    };
  },
  methods: {
    moment,
    //翻页
    changepage(e) {
      this.pagination.pageindex = e.current;
      this.pagination.pagesize = e.pageSize;
      this.query();
    },
    //批量选取
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    showmodel(record) {
      this.visible = true;
      let params = {
        ID: record.ID,
      };
      this.axios
        .post("/accounttrans/getaccounttranssaleuserbyid", params)
        .then((res) => {
          if (res.data) {
            this.edit.ID = res.data[0].ID;
            this.edit.UserId = res.data[0].UserId;
            this.edit.SaleUser = res.data[0].SaleUser;
            this.edit.VIPLevel = res.data[0].VIPLevel;
            this.edit.SlotLevel = res.data[0].SlotLevel;
            this.edit.LiveLevel = res.data[0].LiveLevel;
            this.edit.SlotupCash = res.data[0].SlotupCash;
            this.edit.SlotWeekBonus = res.data[0].SlotWeekBonus;
            this.edit.SlotMonthBonus = res.data[0].SlotMonthBonus;
            this.edit.LiveWeekBonus = res.data[0].LiveWeekBonus;
            this.edit.LiveMonthBonus = res.data[0].LiveMonthBonus;
             this.edit.LiveupCash = res.data[0].LiveupCash;
            this.edit.SalePrices = res.data[0].SalePrices;
            this.edit.State = res.data[0].State.toString();
            this.edit.Memo = res.data[0].Memo;
            this.edit.Fdt = res.data[0].Fdt;
            this.edit.Ldt = res.data[0].Ldt;
          }
        });
    },
    query() {
      let params = {
        SaleUser: this.input.SaleUser,
        State: this.input.State,
        Type: 3,
        pageindex: this.pagination.pageindex,
        pagesize: this.pagination.pagesize,
        UserID: this.input.UserID,
      };
      this.axios
        .post("/accounttrans/getaccounttransrecoverlist", params)
        .then((res) => {
          this.datarow = res.data;
          this.pagination.total = res.total;
        });
    },
    save() {
      let params = {
        ID: parseInt(this.edit.ID),
        UserId: this.edit.UserId,
        SaleUser: this.edit.SaleUser,
        VIPLevel: parseInt(this.edit.VIPLevel),
        SlotLevel: parseInt(this.edit.SlotLevel),
        LiveLevel: parseInt(this.edit.LiveLevel),
        SlotupCash: parseFloat(this.edit.SlotupCash),
        SlotWeekBonus: parseFloat(this.edit.SlotWeekBonus),
        SlotMonthBonus: parseFloat(this.edit.SlotMonthBonus),
        LiveupCash: parseFloat(this.edit.LiveupCash),
        LiveWeekBonus: parseFloat(this.edit.LiveWeekBonus),
        LiveMonthBonus: parseFloat(this.edit.LiveMonthBonus),
        SalePrices: parseFloat(this.edit.SalePrices),
        State: parseInt(this.edit.State),
        Memo: this.edit.Memo,
        Type: 3,
        Operation: 2,
      };

      let url = "/accounttrans/accounttransrecoversave";

      this.axios.post(url, params).then((res) => {
        if (res.data) {
          this.$message.success("修改成功");
          this.query();
          this.visible = false;
        }
      });
    },
    deleteMsg(record) {
      const that = this;
      this.$confirm({
        title: "删除数据",
        content: "您要确定要删除勾选数据吗?",
        onOk() {
          let params = {
            ID: record.ID,
          };

          that.axios
            .post("/accounttrans/accounttransrecoverdelete", params)
            .then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.query();
              }
            });
        },
      });
    },
    // 提交导出
    SubmitExport() {
      const that = this;
      this.$confirm({
        title: "导出",
        content: "确定要导出数据吗？",
        onOk() {
          that.exportData();
        },
      });
    },
    //导出
    exportData() {
      let today = new Date();
       
      this.$message.success("开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢");
      this.axios({
        url: "/accounttrans/exportaccounttransrecoverlist",
        method: "get",
        params: {
          SaleUser: this.input.SaleUser,
          UserID: this.input.UserID,
          Status: this.input.State,
          Type: 3,
        },
        responseType: "blob",
      }).then((response) => {
        let blob = new Blob([response.data], { type: response.data.type });
        // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = "帐号回收导出- "+today.toISOString().split('T')[0]; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉 blob 对象
        }
      });
    },
    batchdelete(type) {
      if (this.selectedRowKeys.length < 1 && type === 1) {
        this.$message.warning("请勾选数据");
        return;
      }
      let url =
        type === 1
          ? "/accounttrans/accounttransrecoverbatchdelete"
          : "/accounttrans/accounttransrecoveralldelete";

      let that = this;
      this.$confirm({
        title: "批量操作",
        content: "您要确定要操作勾选数据吗?",
        onOk() {
          let IDList = [];
          that.selectedRowKeys.forEach((element) => {
            IDList.push({ ID: element });
          });
          that.axios
            .post(url, {
              IDList: IDList,
              Type: 3,
            })
            .then((res) => {
              if (res.data) {
                that.$message.success("操作成功");
                that.query();
              }
            });
        },
      });
    },
  },
  watch: {
    $route(to, from) {
      if (to.name === "accountrecovery") {
        this.input.State = "0";
        if (!stringIsNullorEmpty(this.$route.params.State)) {
          this.input.State = this.$route.params.State;
        }
        this.query();
      }
    },
  },
  //首次加载
  created() {
    if (this.$route.name === "accountrecovery") {
      this.input.State = stringIsNullorEmpty(this.$route.params.State)
        ? "0"
        : this.$route.params.State;
    }
    this.query();
  },
};

const IninTable = function IninTable() {
  var header = [];

  header.push({ title: "ID", align: "center", width: 50, dataIndex: "ID" });
  header.push({
    title: "回收账号",
    align: "center",
    dataIndex: "SaleUser",
  });
  header.push({
    title: "账号ID",
    align: "center",
    dataIndex: "UserId",
  });
  header.push({
    title: "VIP等级",
    align: "center",
    dataIndex: "VIPLevel",
  });
  header.push({
    title: "电子等级",
    align: "center",
    dataIndex: "SlotLevel",
  });
  header.push({
    title: "真人等级",
    align: "center",
    dataIndex: "LiveLevel",
  });
  header.push({
    title: "出售金额",
    align: "center",
    dataIndex: "SalePrices",
  });
  header.push({
    title: "状态",
    align: "center",
    scopedSlots: { customRender: "State" },
  });
  header.push({
    title: "发布时间",
    align: "center",
    dataIndex: "Fdt",
  });
  header.push({
    title: "操作",
    align: "center",
    scopedSlots: { customRender: "Operation" },
    width: 200,
  });

  return header;
};

function stringIsNullorEmpty(value) {
  return !value || value == undefined || value == "" || value.length == 0;
}
</script>

<style>
#editor1 {
  height: 200px;
}
.borderclass {
  border: 1px solid rgb(211, 204, 204);
  width: 50%;
}
.borderclass2 {
  border: 1px solid rgb(211, 204, 204);
  border-top: 0px;
  width: 98%;
}
.marr10 {
  margin-right: 10px;
  background-color: green;
}
</style>


// WEBPACK FOOTER //
// src/components/accounttransaction/accountrecovery.vue